"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbsUp = void 0;
var react_1 = __importDefault(require("react"));
var ThumbsUp = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { d: "M0 16H2.90909V6.4H0V16ZM16 7.2C16 6.32 15.3455 5.6 14.5455 5.6H9.95636L10.6473 1.944L10.6691 1.688C10.6691 1.36 10.5455 1.056 10.3491 0.84L9.57818 0L4.79273 5.272C4.52364 5.56 4.36364 5.96 4.36364 6.4V14.4C4.36364 15.28 5.01818 16 5.81818 16H12.3636C12.9673 16 13.4836 15.6 13.7018 15.024L15.8982 9.384C15.9636 9.2 16 9.008 16 8.8V7.2Z", fill: "currentColor" }))); };
exports.ThumbsUp = ThumbsUp;
